var map = {
	"./puzzle4.jpg": "6d6e",
	"./puzzle4.mp3": "6dba",
	"./puzzle4_1.jpg": "c16e",
	"./puzzle4_1.mp3": "ea90",
	"./puzzle4_2.jpg": "3f89",
	"./puzzle4_2.mp3": "3c5e",
	"./puzzle4_3.jpg": "637a",
	"./puzzle4_3.mp3": "56c9",
	"./puzzle4_4.jpg": "0249",
	"./puzzle4_4.mp3": "2d33",
	"./puzzle4_5.jpg": "8aab",
	"./puzzle4_5.mp3": "8580",
	"./puzzle4_6.jpg": "28f8",
	"./puzzle4_6.mp3": "fc14",
	"./puzzle4_7.jpg": "4817",
	"./puzzle4_7.mp3": "92d2",
	"./puzzle4_8.jpg": "5806",
	"./puzzle4_8.mp3": "4586",
	"./puzzle4_9.jpg": "1aa3",
	"./puzzle4_9.mp3": "b282",
	"./puzzle4_b1.png": "d890",
	"./puzzle4_b2.png": "d294",
	"./puzzle4_b3.png": "a9b6",
	"./puzzle4_b4.png": "109d",
	"./puzzle4_b5.png": "e52b",
	"./puzzle4_b6.png": "d745",
	"./puzzle4_b7.png": "25a1",
	"./puzzle4_b8.png": "b367",
	"./puzzle4_b9.png": "84cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b95";